import React from 'react';

export type TabChild = React.ReactElement<{ name: string }> | null;

export function getNamesFromChildren<T extends TabChild>(children: T | T[] | undefined) {
    return React.Children.map(children, (child) => child?.props.name) ?? [];
}
